export const enum ReportType {
  Undefined = 0,
  LogYardStatus = 1,
  LogYardPeriod = 2,
}
